import { useCallback, useEffect, useState } from 'react';

export type BatchStatus = 'complete' | 'open' | 'upcoming';

export type PhoneBatch = {
  number: number;
  shipLabel: string;
  size: number;
  sold: number;
  remaining: number;
  status: BatchStatus;
};

export type PhoneInventory = {
  total: number;
  sold: number;
  remaining: number;
  soldOut: boolean;
  currentBatch: number | null;
  currentBatchShipLabel: string | null;
  currentBatchRemaining: number;
  currentBatchSize: number;
  currentBatchSold: number;
  nextOrderBatch: number | null;
  nextOrderShipLabel: string | null;
  batches: PhoneBatch[];
};

const FALLBACK: PhoneInventory = {
  total: 50,
  sold: 3,
  remaining: 47,
  soldOut: false,
  currentBatch: 1,
  currentBatchShipLabel: 'September 1, 2026',
  currentBatchRemaining: 7,
  currentBatchSize: 10,
  currentBatchSold: 3,
  nextOrderBatch: 1,
  nextOrderShipLabel: 'September 1, 2026',
  batches: [
    { number: 1, shipLabel: 'September 1, 2026', size: 10, sold: 3, remaining: 7, status: 'open' },
    { number: 2, shipLabel: 'September 30, 2026', size: 10, sold: 0, remaining: 10, status: 'upcoming' },
    { number: 3, shipLabel: 'October 17, 2026', size: 10, sold: 0, remaining: 10, status: 'upcoming' },
    { number: 4, shipLabel: 'January 17, 2027', size: 10, sold: 0, remaining: 10, status: 'upcoming' },
    { number: 5, shipLabel: 'March 30, 2027', size: 10, sold: 0, remaining: 10, status: 'upcoming' },
  ],
};

export function usePhoneInventory(pollMs = 30000) {
  const [inventory, setInventory] = useState<PhoneInventory>(FALLBACK);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    try {
      const res = await fetch('https://selflabs.xyz/.netlify/functions/phone-inventory');
      if (!res.ok) throw new Error('Could not load availability');
      const data = (await res.json()) as PhoneInventory;
      setInventory(data);
      setError(null);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Could not load availability');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
    const id = window.setInterval(refresh, pollMs);
    return () => window.clearInterval(id);
  }, [pollMs, refresh]);

  return { inventory, loading, error, refresh };
}